<div class="sh-fixed-header-panel">
    <div class="sh-fixed-header-panel__head">
        <div class="sh-fixed-header-panel__head__title">{{ "facets.title" | translate }}</div>
        <sh-facet-summary
            *ngIf="(selectedFacets$ | async)?.length"
            [selectedFacets]="selectedFacets$ | async"
            [chosenFiltersMsg]="'facets.summary.chosen' | translate"
            [clearMsg]="'facets.summary.clear' | translate"
            (clear)="onClear()"
            (removeFacetValue)="onRemoveFacet($event)"
        ></sh-facet-summary>
    </div>
    <!--  Not sure why, but this div can receive focus. Disable it with tabindex -1  -->
    <div class="sh-fixed-header-panel__content" tabindex="-1">
        @if (facetsLoading$ | async) {
            @if (!(error$ | async)) {
                <div class="sh-facet-list" [@fadeOut]>
                    <sh-facet-placeholder *ngFor="let _ of [].constructor(4)"></sh-facet-placeholder>
                </div>
            }
        }
        @if (error$ | async) {
            <p>{{ "ui.loading-failed" | translate }}</p>
        } @else {
            @if (selectableFacets$ | async; as facets) {
                @if (extendedFacetProfile$ | async; as facetProfile) {
                    @if (!(facetsLoading$ | async)) {
                        <sh-facet-list
                            *ngIf="facets.length > 0; else noFilters"
                            [ngStyle]="{ display: (facetsLoading$ | async) ? 'none' : 'inherit' }"
                            [facets]="facets"
                            [showMoreMsg]="'facets.search-more' | translate"
                            (facetSelected)="onFacetSelected($event)"
                            (loadMore)="onLoadMore($event, facetProfile)"
                            [@fadeIn]
                        ></sh-facet-list>
                    }
                }
            }
        }
        @if (missingFacetProfile) {
            <ng-container [ngTemplateOutlet]="noFilters"></ng-container>
        }
    </div>
</div>

<ng-template #noFilters>{{ "facets.no-results" | translate }}</ng-template>
